import { IGroupService } from '../../services';
import { Helper } from '../../common';

export interface IModelWidgetService {
    selectedGroupGuid(value?: string): string;
    addChild(movedItemGuid: string, group: any): angular.IPromise<any>;
}

export class ModelWidgetService implements IModelWidgetService {
    static serviceId = 'modelWidgetService';
    private _selectedGroupGuid: string;

    static $inject = ['$q', 'groupService'];

    constructor(
        private _$q: angular.IQService,
        private _groupService: IGroupService) {
    }

    selectedGroupGuid(value?: string): string {
        if (arguments.length > 0) {
            this._selectedGroupGuid = value;
        }
        return this._selectedGroupGuid;
    }

    addChild(movedItemGuid: string, group: any): angular.IPromise<any> {
        const defered = this._$q.defer();

        if (movedItemGuid) {
            if (movedItemGuid !== group.guid) {
                this._groupService
                    .isChildOrSubChild(group.guid, movedItemGuid)
                    .then(result => {
                        if (!result) {
                            return this._groupService.getByGuid(movedItemGuid);
                        } else {
                            defered.reject({ level: 1, message: 'Cannot add a parent to one of its children.' });
                        }
                    })
                    .then(foundGroup => {
                        if (foundGroup && foundGroup.group) {
                            foundGroup.group.parentGUID = group.guid;
                            return this._groupService.updateGroup(foundGroup.group);
                        } else {
                            defered.reject({ level: 2, message: 'Group not found' });
                        }
                    })
                    .then(groupsDto => {
                        defered.resolve({ level: 0, message: 'Successfully updated group.' });
                    })
                    .catch(reason => defered.reject({ level: 1, mesage: 'Failed to update group.' }));
            } else {
                defered.reject({ level: 1, message: 'Cannot add a group on itself' });
            }
        } else {
            const g = {
                parentGUID: group.guid,
                name: '',
                guid: Helper.getGuid()
            };
            if (!group.children) {
                group.children = [];
            }
            this._groupService
                .addGroup(g)
                .then(result => {
                    this.selectedGroupGuid(g.guid);
                    defered.resolve({ level: 0, mesage: 'Successfully created group.' });
                })
                .catch(reason => defered.reject({ level: 2, message: 'Failed to create group.' }));
        }
        return defered.promise;
    }
}